import api from "@/api";
import i18n from "@/i18n";

const { t } = i18n.global;

export default {
  state: {
    policyFiles: [],
    policyFileId: "",
  },
  getters: {
    policyFiles: (state) => state.policyFiles,
    policyFileId: (state) => state.policyFileId,
  },
  mutations: {
    setPolicyFiles: (state, data) => {
      state.policyFiles = data;
    },

    setPolicyFileId: (state, data) => {
      state.policyFileId = data;
    },
  },
  actions: {
    async addPolicy({ commit }, {
        customerId,
        companyId,
        agentId,
        agentId2,
        saleCategory,
        policyMandate,
        policyServices,
        submissionDate,
        teamId
      }) {
      try {
        const response = await api({ requiresAuth: true }).post("/v1/policies", {
          customer_id: customerId,
          company_id: companyId,
          agent_id: agentId,
          policy_mandate: policyMandate,
          policy_services: policyServices,
          submit_date: submissionDate,
          team_id: teamId,
          second_agent_id: agentId2,
          second_agent_sales_category_id: saleCategory,
        });
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.policyCreatedSuccessfully")
        }, { root: true });
        return response;
      } catch (error) {
        commit("setToast", {
          display: true,
          type: "error",
          message: error.response?.data?.message || t("messages.failedToCreatePolicy")
        }, { root: true });
        throw error;
      }
    },

    updatePolicyStatus: async ({ commit }, { policyId, policyStatusId }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policies/${policyId}/statuses`,
          {
            policy_status_id: policyStatusId,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.policyStatusUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdatePolicyStatus")
        }, { root: true });
        throw err;
      }
    },

    updatePolicyAgent: async ({ commit }, { policyId, policyAgentId }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policies/${policyId}/agents`,
          {
            agent_id: policyAgentId,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.policyAgentUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdatePolicyAgent")
        }, { root: true });
        throw err;
      }
    },

    updatePolicyNumber: async ({ commit }, { policyId, policyNumber }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policies/${policyId}/policyNumbers`,
          {
            policy_number: policyNumber,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.policyNumberUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdatePolicyNumber")
        }, { root: true });
        throw err;
      }
    },

    updatePlateNumber: async ({ commit }, { policyId, plateNumber }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policies/${policyId}/plateNumber`,
          {
            plate_number: plateNumber,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.plateNumberUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdatePlateNumber")
        }, { root: true });
        throw err;
      }
    },

    updateSubmitDate: async ({ commit }, { policyId, submitDate }) => {
      try {
        await api({ requiresAuth: true }).patch(
          `/v1/policies/${policyId}/submitDate`,
          {
            submit_date: submitDate,
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.submitDateUpdatedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: err.response?.data?.message || t("messages.failedToUpdateSubmitDate")
        }, { root: true });
        throw err;
      }
    },

    async addPolicyFile({ commit }, { policyId, files }) {
      const formData = new FormData();
      files.forEach((file) => {
        formData.append("policy_files[]", file);
      });
      try {
        await api({ requiresAuth: true }).post(
          `/v1/policies/${policyId}/files`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        commit("setToast", {
          display: true,
          type: "success",
          message: t("messages.policyFilesUploadedSuccessfully")
        }, { root: true });
      } catch (err) {
        commit("setToast", {
          display: true,
          type: "error",
          message: t("messages.failedToUploadPolicyFiles")
        }, { root: true });
        throw err;
      }
    },
  },
};
